// NATIVE 
import * as React from 'react';


// INSTALLED 
import { Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


// CUSTOM 
import { IDCard } from '../../../pages/carnet/IDCard';




const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));



 
export const DialogCarnet = (props:any) =>  {


  //  PROPS 
  const{ open, handleCloseModalCarnet, buttons = false, dataEmployee } = props;



  const [data, setData] = React.useState({
    marcoCarnet: 'N/A',
    employee_avatar: 'N/A',
    name: 'N/A',
    last_name: 'N/A',
    position: 'N/A',
    document_number: 'N/A',
    rh: 'N/A',
    company: 'N/A'
  });




  React.useEffect(() => {
    
    if(dataEmployee){
      setData({
        marcoCarnet: 'N/A',
        employee_avatar: dataEmployee.employee_avatar ?? 'N/A',
        name: dataEmployee.name ?? 'N/A',
        last_name: dataEmployee.last_name ?? 'N/A',
        position: dataEmployee.position?.name ?? 'N/A',
        document_number: dataEmployee.document_number ?? 'N/A',
        rh: dataEmployee.rh ?? 'N/A',
        company: dataEmployee.company?.tradename ?? 'N/A'
      });
    }

  }, [dataEmployee]);
  
  // CONST FUNCTIONS 
  const handleClose = () => {
    handleCloseModalCarnet(false);
  };

  
  

  return (
    <React.Fragment>
      
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="lg" 
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Imprimir Carnet Empleado
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
            <IDCard
                marco={data.marcoCarnet}
                foto={data.employee_avatar}
                nombre={data.name+ ' '+ data.last_name}
                cargo={data.position}
                documento={data.document_number}
                tipoSangre={data.rh}
                empresa={data.company}
            />

        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}




